/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit } from '@angular/core';
import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';

@Component({
  selector: 'app-formularios',
  templateUrl: './formularios.component.html',
  styleUrls: ['./formularios.component.css']
})
export class FormulariosComponent implements OnInit {

  respuesta: DescargaRespuesta;

  constructor(private service: DescargaService) {
    this.respuesta = new DescargaRespuesta();
  }

  ngOnInit() {
    this.service.getAll('files-formularios').subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }

}
